// ----------------------------------------------------------------------

import type { Author, Initiator, RecordStatusId } from '../types/common.types';

export type RecordStatus = {
  id: number;
  author_id: number;
  initiator_id: number;
  created_at: string;
  updated_at: string;
  author?: Author;
  initiator?: Initiator;
  parent_id: number;
  alias: string;
  name: string;
  description: string;
};

// ----------------------------------------------------------------------

export type Classification = {
  id: number;
  author_id: number;
  initiator_id: number;
  created_at: string;
  updated_at: string;
  author: Author;
  initiator: Initiator;
  parent_id: number;
  name: string;
  description: string;
  alias: string;
  record_status_id: RecordStatusId;
  record_status?: RecordStatus;
  has_children: boolean;
};

// ----------------------------------------------------------------------

export type ClassificationWithChildren = Omit<Classification, 'record_status'> & {
  children: ClassificationWithChildren[];
};

// ----------------------------------------------------------------------

export type ClassificationWithParent = Classification & {
  parent?: Classification | undefined;
};

export const CLASSIFICATION_ATC = 'atc';
export const CLASSIFICATION_MU = 'mu';
export const CLASSIFICATION_CATEGORY = 'category';
export const CLASSIFICATION_FORM = 'form';
export const CLASSIFICATION_CATDICT = 'catdict';

export type ClassificationAlias =
  | typeof CLASSIFICATION_ATC
  | typeof CLASSIFICATION_MU
  | typeof CLASSIFICATION_CATEGORY
  | typeof CLASSIFICATION_FORM
  | typeof CLASSIFICATION_CATDICT;
